/**
 * Proposer l'enregistrement d'un contenu déjà reçu (`Blob`) sous un nom donné.
 *
 * Un simple lien vers l'API ne marche pas : le navigateur n'y joindrait pas le
 * jeton d'accès (`Authorization`), qui ne voyage pas dans un cookie. Le
 * contenu est donc lu par le client HTTP, puis remis au navigateur sous une
 * adresse locale (`blob:`), le temps du clic.
 */
export function enregistrerSous(contenu: Blob, nom: string): void {
  const adresse = URL.createObjectURL(contenu)
  const lien = document.createElement('a')
  lien.href = adresse
  lien.download = nom
  lien.rel = 'noopener'
  document.body.appendChild(lien)
  lien.click()
  lien.remove()
  // Révoquée APRÈS le départ du téléchargement : révoquée dans le même tic,
  // certains navigateurs l'abandonnent avant d'avoir lu le contenu.
  setTimeout(() => URL.revokeObjectURL(adresse), 30_000)
}

/**
 * Nom de fichier porté par un en-tête `Content-Disposition` (RFC 6266), ou
 * `null`. `filename*` (UTF-8, pourcent-encodé) prime : c'est le vrai nom ;
 * `filename` n'en est que le repli ASCII. Le serveur est la seule source du
 * nom : le recalculer ici serait une seconde règle, qui divergerait.
 */
export function nomDeDisposition(entete: string | null | undefined): string | null {
  if (!entete) return null
  const etendu = /filename\*\s*=\s*(?:UTF-8|utf-8)''([^;]+)/.exec(entete)
  if (etendu?.[1]) {
    try {
      const nom = decodeURIComponent(etendu[1].trim()).trim()
      if (nom !== '') return nom
    } catch {
      // Mal encodé : le repli ASCII ci-dessous.
    }
  }
  const simple = /filename\s*=\s*"((?:[^"\\]|\\.)*)"|filename\s*=\s*([^;\s]+)/.exec(entete)
  const nom = (simple?.[1] ?? simple?.[2] ?? '').replace(/\\(.)/g, '$1').trim()
  return nom === '' ? null : nom
}
